import React from 'react'
import Aos from 'aos'
import PKS1 from '../../Images/HR/PrastabitKaryaSamiti/LateKrishnaPrasadDahal.JPG'
import PKS2 from '../../Images/HR/PrastabitKaryaSamiti/BalaramPokhrel.jpg'
import PKS3 from '../../Images/HR/PrastabitKaryaSamiti/KrishnaPrasadBhurtel.jpg'
import PKS4 from '../../Images/HR/PrastabitKaryaSamiti/RabindraKrishnaShrestha.jpg'
import PKS5 from '../../Images/HR/PrastabitKaryaSamiti/FadindraPaudel.jpg'
import PKS6 from '../../Images/HR/PrastabitKaryaSamiti/LokPrasadBhattarai.jpg'
import PKS7 from '../../Images/HR/PrastabitKaryaSamiti/ChudamaniDulal.jpg'
import PKS8 from '../../Images/HR/PrastabitKaryaSamiti/BharatiGuragaiBaral.jpg'
import PKS9 from '../../Images/HR/PrastabitKaryaSamiti/BishnuKumariRai.jpg'
import PKS10 from '../../Images/HR/PrastabitKaryaSamiti/NageshPokrel.jpg'
import PKS11 from '../../Images/HR/PrastabitKaryaSamiti/AnjanaSangraulaDhakal.jpg'
import PKS12 from '../../Images/HR/PrastabitKaryaSamiti/BhaktiPrasadDhakal.jpg'
import PKS13 from '../../Images/HR/PrastabitKaryaSamiti/JiwanKhatiwoda.jpg'
import PKS14 from '../../Images/HR/PrastabitKaryaSamiti/KesabPrasadPokhrel.jpg'
import PKS15 from '../../Images/HR/PrastabitKaryaSamiti/UmeshUpreti.jpg'
import PKS16 from '../../Images/HR/PrastabitKaryaSamiti/BinaDhakalSitaula.jpg'
import PKS17 from '../../Images/HR/PrastabitKaryaSamiti/PostaKumarShrestha.jpg'
import PKS18 from '../../Images/HR/PrastabitKaryaSamiti/MohanChudal.jpg'

const PrastabitKaryasamiti = () => {

    Aos.init({
        duration: 1500,
        once: false,
        mirror: false,
        easing: 'ease-in-out-sine'
    });

    const prastabitKaryaList = [
        {
            id: '1',
            memName: 'स्व. कृष्णप्रसाद दाहाल',
            post: 'अध्यक्ष',
            memImg: PKS1
        },
        {
            id: '2',
            memName: 'बलराम पोखरेल',
            post: 'उपाध्यक्ष',
            memImg: PKS2
        },
        {
            id: '3',
            memName: 'कृष्णप्रसाद भूर्तेल',
            post: 'सचिव',
            memImg: PKS3
        },
        {
            id: '4',
            memName: 'रविन्द्रकृष्ण श्रेष्ठ',
            post: 'सहसचिव ',
            memImg: PKS4
        },
        {
            id: '5',
            memName: 'फडिन्द्र पौडेल',
            post: 'कोषाध्यक्ष ',
            memImg: PKS5
        },
        {
            id: '6',
            memName: 'लोकप्रसाद भट्टराई',
            post: 'सहकोषाध्यक्ष ',
            memImg: PKS6
        },
        {
            id: '7',
            memName: 'चूडामणि दुलाल',
            post: 'सदस्य',
            memImg: PKS7
        },
        {
            id: '8',
            memName: 'भारती गुरागाईं बराल',
            post: 'सदस्य',
            memImg: PKS8
        },
        {
            id: '9',
            memName: 'विष्णुकुमारी राई',
            post: 'सदस्य',
            memImg: PKS9
        },
        {
            id: '10',
            memName: 'नागेश पोखरेल',
            post: 'सदस्य',
            memImg: PKS10
        },
        {
            id: '11',
            memName: 'अन्जना संग्रौला ढकाल',
            post: 'सदस्य',
            memImg: PKS11
        },
        {
            id: '12',
            memName: 'भक्तिप्रसाद ढकाल',
            post: 'सदस्य',
            memImg: PKS12
        },
        {
            id: '13',
            memName: 'जीवन खतिवडा',
            post: 'सदस्य',
            memImg: PKS13
        },
        {
            id: '14',
            memName: 'केशवप्रसाद पोखरेल',
            post: 'सदस्य',
            memImg: PKS14
        },
        {
            id: '15',
            memName: 'उमेश उप्रेती',
            post: 'सदस्य',
            memImg: PKS15
        },
        {
            id: '16',
            memName: 'विना ढकाल सिटौला',
            post: 'सदस्य',
            memImg: PKS16
        },
        {
            id: '17',
            memName: 'पोष्टकुमार श्रेष्ठ',
            post: 'सदस्य',
            memImg: PKS17
        },
        {
            id: '18',
            memName: 'मोहन चूडाल',
            post: 'सदस्य',
            memImg: PKS18
        },
    ]

    return (
        <>
            <div className='main'>
                <div className='left-fixed'></div>
                <div className='container'>
                    <div className='heading1' data-aos='fade-right'>
                        <div className='h2'>
                            <h2>प्रस्तावीत कार्यसमिति</h2><hr />
                        </div>
                    </div>
                    <div className='president2' data-aos='fade-right'>
                        {prastabitKaryaList.map((item, index) => {
                            return (
                                <div className='president2-body' key={index}>
                                    <div className='president2-img'>
                                        <img src={item.memImg} alt='AccountComittee' />
                                    </div>
                                    <div className='president2-detail'>
                                        <h2>{item.memName}</h2>
                                        <h3>{item.post}</h3>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
                <div className='right-fixed'></div>
            </div>
        </>
    )
}

export default PrastabitKaryasamiti